<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/Publications/Storage/Files/table-headers'
import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTablePublicationStorageFiles',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
    hasUsers: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    headersFiltered() {
      return this.hasUsers
        ? this.headers
        : this.headers.filter((_) => _.value !== 'ates')
    },
  },
}
</script>
